import { render } from "./RewardPopup.vue?vue&type=template&id=766b2df0&scoped=true"
import script from "./RewardPopup.vue?vue&type=script&lang=js"
export * from "./RewardPopup.vue?vue&type=script&lang=js"

import "./RewardPopup.vue?vue&type=style&index=0&id=766b2df0&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766b2df0"]])

export default __exports__